import React, { useEffect, useState } from 'react';
import { useHook as equipmentHook } from './useHook';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@mui/material';
import { useAlert } from '../../../components/Notification';
import { useHook as globalAlertHook } from '../alert/useHook';
interface EquipmentAlertProps {
  equipmentDetailsData: any;
  refreshKey?: any;
}

const EquipmentAlert: React.FC<EquipmentAlertProps> = ({
  equipmentDetailsData,
  refreshKey,
}) => {
  const userRole = localStorage.getItem('role');
  const [alertList, setAlertList] = useState<any>(null);
  const { fetchAlertList, fetchDealerAlertList } = equipmentHook();
  const { markAsRead } = globalAlertHook();
  const { id } = useParams();
  const showAlert = useAlert();
  const navigate = useNavigate();
  //Get Alert List
  const getreadUnitParameter = async () => {
    if (userRole === 'dealer') {
      await fetchDealerAlertList({ unitID: id })
        .then((response) => {
          setAlertList(response);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      await fetchAlertList({ unitID: id })
        .then((response) => {
          setAlertList(response);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  //dateformat
  function formatDate(isoDate: string | Date) {
    const months = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ];

    const date = new Date(isoDate);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  useEffect(() => {
    getreadUnitParameter();
  }, [refreshKey]);

  // markAsRead
  // const handleMarkAsRead = async (id: string[], action: boolean) => {
  //   const payload = {
  //     alertIDs: id,
  //     action,
  //   };
  //   await markAsRead(payload).then((res) => {
  //     if (res) {
  //       action
  //         ? showAlert('Changed to Read Successfully', 'success')
  //         : showAlert('Changed to Unread Successfully', 'success');
  //     }
  //   });
  //   await getreadUnitParameter();
  // };

  return alertList?.length > 0 ? (
    <>
      <section className="equipment_information">
        <div className="equipment_information_heading">
          <h5>Alerts</h5>
          <Button
            onClick={() =>
              navigate('/alert', {
                state: {
                  id: id,
                  equipmentType: equipmentDetailsData?.equipmentType
                    ? equipmentDetailsData?.equipmentType
                    : '',
                },
              })
            }
          >
            View All
          </Button>
        </div>
        <div className="equipment_information-content">
          {alertList
            ?.reverse()
            ?.slice(0, 5)
            ?.map((alertData: any, index: number) => (
              <div
                key={index}
                className={
                  alertData?.isUnread
                    ? 'equipment_alert alert_body_unread'
                    : 'equipment_alert '
                }
              >
                <div className="equipment_alert-heading">
                  <h5>{alertData?.title}</h5>
                  <div className="equipment_alert-read_unread">
                    <h6>Created date : {formatDate(alertData?.createdAt)}</h6>
                    {/* <div className="markus_read_unread-btn">
                    <Button
                    onClick={() =>
                      handleMarkAsRead(
                        [alertData?.alertID],
                        alertData?.isUnread,
                      )
                    }
                    >
                      {alertData?.isUnread ? 'Mark as read' : 'Mark as Unread'}
                    </Button>
                  </div> */}
                  </div>
                </div>
                <p>{alertData?.description}</p>
              </div>
            ))}
        </div>
      </section>
    </>
  ) : (
    <></>
  );
};

const MemoizedComponent = React.memo(EquipmentAlert);
export default MemoizedComponent;
